import { CheckinPublishCustomer, getListPublish, PublishAPI } from "./api/publish";
import APIFile from "./api/file";

const publishApi = new PublishAPI();
const fileApi = new APIFile();

export class PublishService {
  getListPublish = async (params: getListPublish) => {
    try {
      const resp = await publishApi.getListPublish(params);
      return resp.data;
    } catch (error) {
      // console.error('Error fetching publish list:', error);
      // console.warn('Returning mock data');
      throw error;
    }
  };

  checkInPublishCustomer = async (params: CheckinPublishCustomer) => {
    let payload: CheckinPublishCustomer = {
      customerId: params.customerId,
      campaignId: params.campaignId,
      image: "",
    };

    // Handle image upload if imageBase64 is provided
    if (params.imageBase64) {
      try {
        if (window.isOffline) {
          // If offline, use the base64 image directly
          payload.image = params.imageBase64;
        } else {
          // Upload the image and get the file ID
          let file = await fileApi.uploadImage(params.imageBase64);
          if (file.folderFileId != null) {
            payload.image = file.folderFileId + "";
          }
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        throw error;
      }
    }

    // Send the check-in request with the uploaded image ID
    const resp = await publishApi.checkInPublishCustomer(payload);
    return resp.data || {};
  };
}
